import ConsultarDenuncia from './ConsultarDenuncia';

export default ConsultarDenuncia;
